import request from '@/utils/request'
const apiPath = '/course/courseSubjectBarrierStudent'
import { downloadBlob } from '@/utils/download'
const courseSubjectBarrierStudentApi = {
  create(data) {
    return request.post(apiPath, data)
  },
  /**
   * 分页查询【课程管理闯关模式阶段】
   */
  fetchList(query) {
    return request.get(apiPath, { params: query })
  },
  fetchUsers(query) {
    return request.get(apiPath + '/getStudentUserList', { params: query })
  },
  /**
   * 
   * 查看【课程管理闯关模式阶段】详情
   */
  fetchById(id) {
    return request.get(`${apiPath}/${id}`)
  },
  /**
   * 删除单个【课程管理闯关模式阶段】
   */
  deleteById(id) {
    return request.delete(`${apiPath}/${id}`)
  },
  import(data) {
    return request.post(apiPath + '/importExcel2', data, { isFormData: 1 })
  },
  downloadExcelTemplate2(query) {
    return request.get(`${apiPath}/downloadExcelTemplate2`, { responseType: 'blob', params: query })
      .then(res => downloadBlob(res, '导入学员模板.xlsx'))
  }

}
export default courseSubjectBarrierStudentApi
